import React from 'react';

// tslint:disable max-line-length
const RIntroContentLocalMuseumTranscriptionMunch: React.FC = () => (
  <>
    <h5>Introduction</h5>
    <p>Hey. This gift has been made... for you. I’ll explain. Someone here wanted to share the objects in this gift with you and recorded messages for each one. Walk around and see if you can find the first one.</p>
  </>
);

export {
  RIntroContentLocalMuseumTranscriptionMunch,
};
